var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","height":"100vh","background-color":"#f5f7fa"}},[_c('el-button',{attrs:{"type":"primary","size":"large"},on:{"click":function($event){return _vm.downloadPDA()}}},[_vm._v("PDA下载")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/views/downloadPda/index.vue?vue&type=template&id=692e96d9&scoped=true&
// module id = null
// module chunks = 